import React, { useCallback } from 'react';
import { resGridStatus1, resGridStatus2, resGridStatus3, resGridStatus4, resGridStatus5, resGridHistory, resGridNotesCheck, resGridNotes, resGridConfidential, resGridTemplateEmpty, resGridImageResult, resButtonsPin, resButtonsRetransm, resGridStatus0, resMail, resWhatsApp, multilineIcon, xrayIcon } from '../../../../../images/icons';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { Button } from 'devextreme-react';
import moment from 'moment';
import { ETypeExternalExportResult, ResultEstadoResult, SysIResultados } from '../../../../../types/types.orders';
import { ResultTypeResult } from '../../../../../types/types.analitos';
import { showModalHistory, showModalNotes } from '../../../../../contexts/slices/orders';
import { newToast } from '../../../..';
import { SysI_CodBarrasImpresoras } from '../../../../../types/types.barcodes';
import { useApiBarcodes } from '../../../../../api/api.barcodes';
import { setModalBarcodePrintersVisible } from '../../../../../contexts/slices/config';
import { LazyPopover, LazyTooltip } from '../components/LazyOverlays';
import { getAlarmAndAbsurdFlag, getAlarmAndAbsurdLabel } from './resultStyles';

// Funciones utilitarias fuera del hook para evitar recreación
const sanitizeForDisplay = (val: any): string => {
  if (val === null || val === undefined) return '';
  if (typeof val === 'object') return JSON.stringify(val);
  return String(val);
};

const SPECIAL_CHARS_REGEX = /[^\w\s]/;

function isNotEmpty(value: any) {
  return value !== undefined && value !== null && value !== '';
}

const getImageByOtherFonts = (type: ETypeExternalExportResult) => {
  switch (type) {
    case ETypeExternalExportResult.CorreoElectronico:
      return resMail;
    case ETypeExternalExportResult.PaginaWebResultados:
      return resGridStatus5;
    case ETypeExternalExportResult.HistoriaClinica:
      return resGridStatus5;
    case ETypeExternalExportResult.SistemaExterno:
      return resGridStatus5;
    case ETypeExternalExportResult.WhatsApp:
      return resWhatsApp;
    default:
      return resButtonsRetransm;
  }
};

const getETypeExternalExportResult = (Fuente: ETypeExternalExportResult) => {
  switch (Fuente) {
    case ETypeExternalExportResult.CorreoElectronico:
      return 'Correo Electronico';
    case ETypeExternalExportResult.PaginaWebResultados:
      return 'Pagina Web Resultados';
    case ETypeExternalExportResult.HistoriaClinica:
      return 'Historia Clinica';
    case ETypeExternalExportResult.SistemaExterno:
      return 'Sistema Externo';
    case ETypeExternalExportResult.WhatsApp:
      return 'WhatsApp';
    default:
      return 'Fuente no definida';
  }
};

export const useApiFunctionsResult = () => {
  const ModuleTracking: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.find((x) => x.Cgn_Nombre === 'ModuleTracking')?.Cgn_Resultado) || 'false');
  const Prm_Res_Conf = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Conf);
  let lstValRefers = useAppSelector((x) => x.configuration.Data?.AnalitosValoresRef);
  const { getPrinters, PrintBarcodeLabels } = useApiBarcodes();
  const dispatch = useAppDispatch();
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');

  //Renderiza la celda de Estados
  const handleStatusResult = useCallback((data?: any, state?: ResultEstadoResult) => {
    let stateHandler = ResultEstadoResult.SinResultado;
    const rowData: SysIResultados = data.data;
    if (state) {
      stateHandler = state;
    } else {
      stateHandler = rowData.Res_Estado;
    }
    switch (stateHandler) {
      case ResultEstadoResult.SinResultado:
      default:
        return (
          <LazyTooltip position='right' content='Analito sin resultados'>
            <img src={resGridStatus1} alt='Sin resultados' />
          </LazyTooltip>
        );
      case ResultEstadoResult.ConResultado:
        return (
          <LazyTooltip position='right' content='Analito con resultados'>
            <img src={resGridStatus2} alt='Con resultado sin validar' />
          </LazyTooltip>
        );
      case ResultEstadoResult.Validado:
        return (
          <LazyTooltip position='right' content={`Analito validado: ${rowData.Res_FechaValidacion ? moment(rowData.Res_FechaValidacion).format('DD/MM/YYYY hh:mm a') : 'Sin fecha'}`}>
            <img src={resGridStatus3} alt='Validado' />
          </LazyTooltip>
        );
      case ResultEstadoResult.Impreso:
        return (
          <LazyTooltip position='right' content={`Analito impreso : ${rowData.Res_FechaImpresion ? moment(rowData.Res_FechaImpresion).format('DD/MM/YYYY hh:mm a') : 'Sin fecha'}`}>
            <img src={resGridStatus4} alt='Impresa' />
          </LazyTooltip>
        );
      case ResultEstadoResult.OtrasFuentes:
        if (!rowData.Res_EnviadoOtrasFuentes) {
          return (
            <LazyTooltip position='right' content='En espera para ser reenviado a fuentes externas'>
              <img src={resButtonsRetransm} alt='En otras fuentes' />
            </LazyTooltip>
          );
        }
        return (
          <LazyTooltip position='right' content={`${getETypeExternalExportResult(rowData.Res_EnviadoOtrasFuentes)}: ${rowData.Res_EnviadoOtrasFuentesFecha ? moment(rowData.Res_EnviadoOtrasFuentesFecha).format('DD/MM/YYYY hh:mm a') : 'Sin fecha'}`}>
            <img src={getImageByOtherFonts(rowData.Res_EnviadoOtrasFuentes)} alt='En otras fuentes' />
          </LazyTooltip>
        );
      case ResultEstadoResult.ValidadoBlanco:
        return (
          <LazyTooltip position='right' content={`Analito con resultado fijado en blanco: ${rowData.Res_FechaValidacion ? moment(rowData.Res_FechaValidacion).format('DD/MM/YYYY hh:mm a') : 'Sin fecha'}`}>
            <img src={resGridStatus0} alt='Fijado como resultado en blanco' />
          </LazyTooltip>
        );
    }
  }, []);

  //#region EVENTOS

  //Evento clic para la celda de historico
  const handleHistoryClick = useCallback((data: SysIResultados) => {
    if (data.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      newToast('WARNING', 'No cuenta con permisos para ver resultados confidenciales', 5);
      return;
    }
    dispatch(showModalHistory({ Visible: true, An_Id: data.Res_An_Id, An_Nombre: data.Analito.An_Nombre, Res_Estado: data.Res_Estado, Res_Id: data.Res_Id, Res_Resultado: data.Res_NotaValidacion, An_Tr_Id: data.Analito.An_Tr_Id, Update: false, Pc_Id: data.Orden.Ord_Pc_Id }));
  }, [Prm_Res_Conf, dispatch]);

  const handlePrintBarcodesLabel = useCallback(async (idOrden: number, lstIdsEstudios?: number[]) => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      if (printer) {
        PrintBarcodeLabels({ IdOrden: idOrden, printer: printer, LstIdsEstudios: lstIdsEstudios });
      }
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        //Seleccionar una impresora como predeterminada
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
        if (printer) {
          PrintBarcodeLabels({ IdOrden: idOrden, printer: printer, LstIdsEstudios: lstIdsEstudios });
        }
      } else {
        //Mostrar modal de varias impresoras
        dispatch(setModalBarcodePrintersVisible(true));
        return;
      }
    }
  }, [ModuleBarcode, getPrinters, PrintBarcodeLabels, dispatch]);

  //Evento clic para la celda de historico
  const handleHistoryNotesValidation = useCallback((data: SysIResultados) => {
    dispatch(showModalNotes({ Visible: true, An_Id: data.Res_An_Id, An_Nombre: data.Analito.An_Nombre, Res_Estado: data.Res_Estado, Res_Id: data.Res_Id, Res_Resultado: data.Res_NotaValidacion, Update: false, Pc_Id: data.Orden.Ord_Pc_Id }));
  }, [dispatch]);
  //#endregion
  //Renderiza la celda de históricos
  const handleHistory = useCallback((data) => {
    const rowData: SysIResultados = data.data;
    return (
      <LazyTooltip position='right' content='Evolutivo paciente'>
        <img
          className='imgClick'
          src={resGridHistory}
          alt='Evolutivo paciente'
          onClick={() => {
            handleHistoryClick(rowData);
          }}
        />
      </LazyTooltip>
    );
  }, [handleHistoryClick]);

  //Renderiza la celda de muestras
  const handleSample = useCallback((data) => {
    const rowData: SysIResultados = data.data;

    // Solo añadiremos un estilo para el contenedor principal para centrarlo
    const cellStyle: React.CSSProperties = {
      display: 'flex',
      marginLeft: 10,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    };

    return (
      <div style={cellStyle}>
        <LazyTooltip
          position='right'
          wrapperClassName='tube-container'
          content={
            <>
              {rowData.Analito.TipoMuestra.Tm_Nombre}
              {ModuleTracking && !rowData.Res_MuestraTrackedada && <p>(Muestra sin tracking)</p>}
            </>
          }>
          <div className='test-tube'>
            <div className='liquid' style={{ backgroundColor: rowData.Analito.TipoMuestra.Tm_Color || '#888' }}></div>
          </div>
          <div className='warning-icon'>{ModuleTracking && !rowData.Res_MuestraTrackedada && '!'}</div>
        </LazyTooltip>
      </div>
    );
  }, [ModuleTracking]);

  //Renderiza la celda de resultado anterior
  const handleAnt = useCallback((data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <LazyTooltip position='right' content='Resultado confidencial'>
          <img src={resGridConfidential} alt='Muestra sin tracking' />
        </LazyTooltip>
      );
    }
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGEN) {
      return <div></div>;
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.PLANTILLA) {
      let result: any[] = [];
      let isValidTemplate = false;
      if (rowData.Res_ResultadoAnterior && !rowData.Res_ResultadoAnterior.includes('||ADJUNTO||')) {
        try {
          const parsed = JSON.parse(rowData.Res_ResultadoAnterior);
          if (Array.isArray(parsed)) {
            result = parsed;
            isValidTemplate = true;
          }
        } catch {
          // El resultado anterior no es JSON válido (probablemente fue guardado con otro tipo de resultado)
          isValidTemplate = false;
        }
      }

      // Si no se pudo parsear como plantilla, mostrar como texto plano
      if (!isValidTemplate && rowData.Res_ResultadoAnterior) {
        if (!rowData.Res_FechaResultadoAnterior) {
          return <div>{sanitizeForDisplay(rowData.Res_ResultadoAnterior)}</div>;
        }
        return (
          <LazyTooltip position='right' content={moment(rowData.Res_FechaResultadoAnterior).format('YYYY/MM/DD HH:mm a') || ''}>
            {sanitizeForDisplay(rowData.Res_ResultadoAnterior)}
          </LazyTooltip>
        );
      }

      return (
        <LazyTooltip
          position='top'
          content={
            <div>
              {Array.isArray(result) &&
                result.map((x: any, index: number) => {
                  const groupKey = sanitizeForDisplay(x.Group) || `group-${index}`;
                  const groupTitle = sanitizeForDisplay(x.Group) || 'Sin nombre';

                  return React.createElement('div', { key: groupKey, className: 'tooltip-content' }, [
                    React.createElement('h6', { key: `title-${index}`, className: 'tooltip-title' }, groupTitle),
                    ...(Array.isArray(x.Items)
                      ? x.Items.map((y: any, itemIndex: number) => {
                          const itemKey = sanitizeForDisplay(y.Key) || `item-${index}-${itemIndex}`;
                          const itemLabel = sanitizeForDisplay(y.Label) || '';
                          const itemValue = sanitizeForDisplay(y.Value);

                          return React.createElement('p', { key: itemKey, className: 'tooltip-item', style: { whiteSpace: 'pre-wrap' } }, [React.createElement('strong', { key: `item-label-${itemKey}` }, `  ${itemLabel}: `), React.createElement('span', { key: `item-value-${itemKey}`, style: { whiteSpace: 'pre-wrap' } }, itemValue)]);
                        })
                      : []),
                  ]);
                })}
            </div>
          }>
          <Button icon={resGridTemplateEmpty} />
        </LazyTooltip>
      );
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoAnterior || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <LazyTooltip
          position='top'
          content={<div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>{textContent}</div>}>
          <Button icon={multilineIcon} />
        </LazyTooltip>
      );
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={xrayIcon} />;
    }

    // Para tipos no-plantilla: verificar si el resultado anterior es un JSON de plantilla antigua
    const displayValueAnt = (() => {
      const raw = rowData.Res_ResultadoAnterior;
      if (!raw || typeof raw !== 'string') return sanitizeForDisplay(raw);
      const trimmed = raw.trim();
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].Group && parsed[0].Items) {
            return parsed
              .map((g: any) => (g.Items || []).map((i: any) => `${i.Label || i.Key}: ${typeof i.Value === 'object' ? JSON.stringify(i.Value) : (i.Value ?? '')}`).join(', '))
              .filter(Boolean)
              .join(' | ');
          }
        } catch {
          // No es JSON, devolver como está
        }
      }
      return sanitizeForDisplay(raw);
    })();

    if (!rowData.Res_FechaResultadoAnterior) {
      return <div>{displayValueAnt}</div>;
    }
    return (
      <LazyTooltip position='right' content={moment(rowData.Res_FechaResultadoAnterior).format('YYYY/MM/DD HH:mm a') || ''}>
        {displayValueAnt}
      </LazyTooltip>
    );
  }, [Prm_Res_Conf]);

  //Renderiza la celda de resultado previo 1
  const handlePreview1 = useCallback((data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <LazyTooltip position='right' content='Resultado confidencial'>
          <img src={resGridConfidential} alt='Muestra sin tracking' />
        </LazyTooltip>
      );
    }

    //Validamos que si el tipo de resultado es plantilla - verificar que el contenido sea JSON válido
    if (rowData.Analito.An_Tr_Id === 4) {
      // Si el resultado previo es JSON válido de plantilla, mostrar icono; si no, mostrar como texto
      if (rowData.Res_ResultadoPrevio1) {
        try {
          const parsed = JSON.parse(rowData.Res_ResultadoPrevio1);
          if (Array.isArray(parsed)) {
            return <Button icon={resGridTemplateEmpty} />;
          }
        } catch {
          // No es JSON válido, fue guardado con otro tipo - mostrar como texto plano
        }
        return (
          <LazyPopover
            position='left'
            title='Resultado previo 1'
            width={300}
            wrapperClassName='imgClick'
            content={
              <>
                <p>
                  <strong>Resultado: </strong> {sanitizeForDisplay(rowData.Res_ResultadoPrevio1)}
                </p>
                <p>
                  <strong>Fecha: </strong> {rowData.Res_FechaPrevio1 ? moment(rowData.Res_FechaPrevio1).format('YYYY/MM/DD HH:mm a') : ''}
                </p>
                {rowData.Res_OrdenPrevio1 && <Button text='Ver orden' type='default' stylingMode='contained' />}
              </>
            }>
            {sanitizeForDisplay(rowData.Res_ResultadoPrevio1)}
          </LazyPopover>
        );
      }
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es imagen
    if (rowData.Analito.An_Tr_Id === 7) {
      return <Button icon={resGridImageResult} />;
    }

    //Validar si el tipo de resultado es imágenes DX
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={xrayIcon} />;
    }

    //Validar si el tipo de resultado es multilínea
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoPrevio1 || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <LazyTooltip
          position='top'
          content={<div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>{textContent}</div>}>
          <Button icon={multilineIcon} />
        </LazyTooltip>
      );
    }

    // Para tipos no-plantilla: verificar si el resultado previo es un JSON de plantilla antigua
    // Si es así, intentar extraer un resumen legible en vez de mostrar JSON crudo
    const displayValuePrev1 = (() => {
      const raw = rowData.Res_ResultadoPrevio1;
      if (!raw || typeof raw !== 'string') return sanitizeForDisplay(raw);
      const trimmed = raw.trim();
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].Group && parsed[0].Items) {
            // Es un JSON de plantilla - extraer valores legibles
            return parsed
              .map((g: any) => (g.Items || []).map((i: any) => `${i.Label || i.Key}: ${typeof i.Value === 'object' ? JSON.stringify(i.Value) : (i.Value ?? '')}`).join(', '))
              .filter(Boolean)
              .join(' | ');
          }
        } catch {
          // No es JSON, devolver como está
        }
      }
      return sanitizeForDisplay(raw);
    })();

    return (
      <LazyPopover
        position='left'
        title='Resultado previo 1'
        width={300}
        wrapperClassName='imgClick'
        content={
          <>
            <p>
              <strong>Resultado: </strong> {displayValuePrev1}
            </p>
            <p>
              <strong>Fecha: </strong> {rowData.Res_FechaPrevio1 ? moment(rowData.Res_FechaPrevio1).format('YYYY/MM/DD HH:mm a') : ''}
            </p>
            {rowData.Res_OrdenPrevio1 && <Button text='Ver orden' type='default' stylingMode='contained' />}
          </>
        }>
        {displayValuePrev1}
      </LazyPopover>
    );
  }, [Prm_Res_Conf]);

  //Renderiza la celda de resultado previo 2
  const handlePreview2 = useCallback((data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <LazyTooltip position='right' content='Resultado confidencial'>
          <img src={resGridConfidential} alt='Muestra sin tracking' />
        </LazyTooltip>
      );
    }

    //Validamos que si el tipo de resultado es plantilla - verificar que el contenido sea JSON válido
    if (rowData.Analito.An_Tr_Id === 4) {
      if (rowData.Res_ResultadoPrevio2) {
        try {
          const parsed = JSON.parse(rowData.Res_ResultadoPrevio2);
          if (Array.isArray(parsed)) {
            return <Button icon={resGridTemplateEmpty} />;
          }
        } catch {
          // No es JSON válido, fue guardado con otro tipo - mostrar como texto plano
        }
        return (
          <LazyPopover
            position='left'
            title='Resultado previo 2'
            width={300}
            wrapperClassName='imgClick'
            content={
              <>
                <p>
                  <strong>Resultado: </strong> {sanitizeForDisplay(rowData.Res_ResultadoPrevio2)}
                </p>
                <p>
                  <strong>Fecha: </strong> {rowData.Res_FechaPrevio2 ? moment(rowData.Res_FechaPrevio2).format('YYYY/MM/DD HH:mm a') : ''}
                </p>
                {rowData.Res_OrdenPrevio2 && <Button text='Ver orden' type='default' stylingMode='contained' />}
              </>
            }>
            {sanitizeForDisplay(rowData.Res_ResultadoPrevio2)}
          </LazyPopover>
        );
      }
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es imagen
    if (rowData.Analito.An_Tr_Id === 7) {
      return <Button icon={resGridImageResult} />;
    }

    //Validar si el tipo de resultado es imágenes DX
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={xrayIcon} />;
    }

    //Validar si el tipo de resultado es multilínea
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoPrevio2 || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <LazyTooltip
          position='top'
          content={<div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>{textContent}</div>}>
          <Button icon={multilineIcon} />
        </LazyTooltip>
      );
    }

    // Para tipos no-plantilla: verificar si el resultado previo es un JSON de plantilla antigua
    const displayValuePrev2 = (() => {
      const raw = rowData.Res_ResultadoPrevio2;
      if (!raw || typeof raw !== 'string') return sanitizeForDisplay(raw);
      const trimmed = raw.trim();
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].Group && parsed[0].Items) {
            return parsed
              .map((g: any) => (g.Items || []).map((i: any) => `${i.Label || i.Key}: ${typeof i.Value === 'object' ? JSON.stringify(i.Value) : (i.Value ?? '')}`).join(', '))
              .filter(Boolean)
              .join(' | ');
          }
        } catch {
          // No es JSON, devolver como está
        }
      }
      return sanitizeForDisplay(raw);
    })();

    return (
      <LazyPopover
        position='left'
        title='Resultado previo 2'
        width={300}
        wrapperClassName='imgClick'
        content={
          <>
            <p>
              <strong>Resultado: </strong> {displayValuePrev2}
            </p>
            <p>
              <strong>Fecha: </strong> {rowData.Res_FechaPrevio2 ? moment(rowData.Res_FechaPrevio2).format('YYYY/MM/DD HH:mm a') : ''}
            </p>
            {rowData.Res_OrdenPrevio2 && <Button text='Ver orden' type='default' stylingMode='contained' />}
          </>
        }>
        {displayValuePrev2}
      </LazyPopover>
    );
  }, [Prm_Res_Conf]);

  //Renderiza la celda de valores de referencia
  const handleValRef = useCallback((data) => {
    const rowData: SysIResultados = data.data;    
    switch (rowData.Analito.An_Tr_Id) {
      case ResultTypeResult.NUMERICO:
      case ResultTypeResult.FORMULA:
        return `${rowData.Res_ValRefMin || 0} - ${rowData.Res_ValRefMax || 0}`;     
      case ResultTypeResult.PLANTILLA:
        return;
      case ResultTypeResult.TEXTUAL:
      case ResultTypeResult.LISTA:
      case ResultTypeResult.AUTOCOMPLETAR:
        case ResultTypeResult.MULTILINEA:
        return `${rowData.Analito.An_ValRefText ? rowData.Analito.An_ValRefText : ''}` || '';
        
      default:
        return;
    }
  }, []);

  //Renderiza la celda de Notas
  const handleNote = useCallback((data) => {
    const rowData: SysIResultados = data.data;
    if (rowData.Res_NotaValidacion) {
      return (
        <LazyTooltip position='right' content='Contiene notas de validación'>
          <img
            className='imgClick'
            src={resGridNotesCheck}
            onClick={() => {
              handleHistoryNotesValidation(rowData);
            }}
            alt='Contiene notas de validación'
          />
        </LazyTooltip>
      );
    }
    return (
      <LazyTooltip position='right' content='Notas de validación'>
        <img
          className='imgClick'
          src={resGridNotes}
          onClick={() => {
            handleHistoryNotesValidation(rowData);
          }}
          alt='Notas de validación'
        />
      </LazyTooltip>
    );
  }, [handleHistoryNotesValidation]);

  //Valida los valores absurdos y alarmas (devuelve la clase de estilo)
  const checkAlarmAndAburd = useCallback((rowData: SysIResultados) => getAlarmAndAbsurdLabel(rowData, lstValRefers), [lstValRefers]);

  //Valida los valores absurdos y alarmas (versión booleana, sin etiqueta de estilo)
  const checkAlarmAndAburdNoLabel = useCallback((rowData: SysIResultados) => getAlarmAndAbsurdFlag(rowData, lstValRefers), [lstValRefers]);

  return { handleHistory, handleSample, handleNote, handleStatusResult, handleValRef, handleAnt, handlePreview2, handlePreview1, checkAlarmAndAburd, checkAlarmAndAburdNoLabel, isNotEmpty, handlePrintBarcodesLabel };
};
